import { render, staticRenderFns } from "./ProviderDetailOPPending.vue?vue&type=template&id=75c3e4f7&"
import script from "./ProviderDetailOPPending.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailOPPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports